export const TriangleRight = (props: any) => (
	<svg
		data-aid="svgTriangleRight"
		width="24"
		height="24"
		viewBox="0 0 12 12"
		fill="currentColor"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M9.25 6.39786C9.58333 6.20541 9.58333 5.72429 9.25 5.53184L3.25 2.06773C2.91667 1.87528 2.5 2.11585 2.5 2.50075V9.42895C2.5 9.81385 2.91667 10.0544 3.25 9.86196L9.25 6.39786Z"
			fill="currentColor"
		/>
	</svg>
);
